import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

export const loginAdmin = (email: string, password: string) =>
  axios.post(`${BASE}/admin-api/login`, { email, password });

export const getMe = () =>
  axios.get(`${BASE}/admin-api/me`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const createUser = (email: string, password: string, role: string) =>
  axios.post(
    `${BASE}/admin-api/users`,
    { email, password, role },
    { headers: { Authorization: `Bearer ${getToken()}` } }
  );

export const saveAgentConfig = (data: {
  agentId1: string;
  agentId2: string;
  validFrom: string;
}) =>
  axios.post(`${BASE}/admin-api/agent-configs`, data, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const getAgentConfigs = () =>
  axios.get(`${BASE}/admin-api/agent-configs`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const deleteAgentConfig = (id: string) =>
  axios.post(`${BASE}/admin-api/agent-configs/${id}/delete`, {}, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const checkAgent = (agentId1: string, agentId2?: string) => {
  const params = new URLSearchParams({ agentId1 });
  if (agentId2) params.append('agentId2', agentId2);
  return axios.get<{ blocked: boolean }>(`${BASE}/admin-api/check-agent?${params}`);
};

export const getToken = (): string | null =>
  localStorage.getItem('admin_token');

export const setToken = (token: string) =>
  localStorage.setItem('admin_token', token);

export const removeToken = () =>
  localStorage.removeItem('admin_token');
